<div class="content left">
  <div class="row">
    <div class="col-12">
      <loader [loading]="isloading"></loader>

      <ng-container *ngIf="!isloading">
        <div class="content-wrapper shadow_none" *ngFor="let note of notes | orderBy: ['ORDER']; let i = index">
          <div class="header">
            <div class="user">
              <div class="d-flex align-items-center">
                <span>{{note.CREATOR?.getName()}}</span>
                <div class="indicator">
                  <span *ngIf="note.CLIENT_VISIBLE" class="visible" tooltip="Visible on Client Link" placement="top"
                    container="body"></span>
                </div>
              </div>
              <label>{{note.DATE_UPDATED | date: 'MM/dd/yyyy hh:mm a'}}</label>
            </div>

          </div>

          <div class="note mt-1">
            <p>{{note.CONTENT ? note.CONTENT : 'Empty Notes'}}</p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>